import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { IAddon } from '@bca-shared/models/addon';
import { ICompany } from '@bca-shared/models/company';
import { IProduct } from '@bca-shared/models/product';
import {ProductStart} from '@bca-user-data/models/_enums';

@Component({
  selector: 'bca-product',
  templateUrl: 'product.component.html',
  styleUrls: ['product.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductComponent {
  @Input()
  product: IProduct;
  @Input()
  productNumber: number;
  @Input()
  totalProductCount: number;
  @Input()
  company: ICompany;

  @Output()
  delete = new EventEmitter<IProduct>();
  @Output()
  edit = new EventEmitter<IProduct>();
  @Output()
  editUser = new EventEmitter<IProduct>();
  @Output()
  deleteAddon = new EventEmitter<IAddon>();
    protected readonly ProductStart = ProductStart;
}
